import MiniGameImages from "../MiniGameImages";

export default class PersonalityQuizPersonaResultsModel {
  public personaId: number = null;
  public title: string = null;
  public description: string | null = null;
  public images: MiniGameImages | null = null;
}
